import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    recommendation:{},
    error:'',
    status:'idle',
    getRecomendation:{}
};

export const fetchRecommendation = createAsyncThunk('recommandation/fetchRecommendation', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getGlobalDisputeRecommendations',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const saveRecommendations = createAsyncThunk('recommandation/saveRecommendations', async (arr) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("recommendations",arr);
    fromData.append("Token",accessToken);
    let response = await axios.post('form/saveUserRecommendations',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}


const RecommendationSlice = createSlice({
    name:'recommandation',
    initialState,
    reducers:{
        blankRecommendation:(state)=>{
            state.recommendation = {};
            state.getRecomendation = {};
            state.status='idle';
        }
    },
    extraReducers:(builder) => {
        builder.addCase(saveRecommendations.fulfilled,(state,action)=>{
            state.recommendation = action.payload
        })
        builder.addCase(fetchRecommendation.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchRecommendation.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.getRecomendation = action.payload;
            state.error = '';
        })
        builder.addCase(fetchRecommendation.rejected,(state,action)=>{
            state.status = 'failed';
            state.getRecomendation = {};
            state.error = action.error.message;
        })
    }
});

export const {blankRecommendation} = RecommendationSlice.actions;

export default RecommendationSlice.reducer;
